import red from "@material-ui/core/colors/red";
import { createSlice } from '@reduxjs/toolkit';

const primaryColor = { main : '#00b1cb' };
const secondaryColor = { main : '#56e23c' };

const themeConfig = {
  primary: primaryColor,
  secondary: secondaryColor,
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: primaryColor,
    secondary: secondaryColor,
    error: red,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: 3,
    // Used to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2
  },
  overrides: {
    MuiTableCell: {
      root: {
        padding: '10px 12px',
      },
    },
    MUIDataTableHeadCell: {
      root: {
        '&:last-child': {
          width: 80
        }
      }
    }
  },
};

export const settings = createSlice({
  name: 'settings',
  initialState: {
    theme: {
      ...themeConfig,
      palette: {
        ...themeConfig.palette,
        primary: localStorage.getItem('fiscall-colors-swapped') === 'true' ? secondaryColor : primaryColor,
        secondary: localStorage.getItem('fiscall-colors-swapped') === 'true' ? primaryColor : secondaryColor,
        type: localStorage.getItem('fiscall-dark-mode') === 'true' ? "dark" : "light"
      }
    },
    darkMode: localStorage.getItem('fiscall-dark-mode') === 'true' || false,
    colorsSwaped: localStorage.getItem('fiscall-colors-swapped') === 'true' || false
  },
  reducers: {
    toggleThemeMode: (state, action) => {
      localStorage.setItem('fiscall-dark-mode', action.payload);
      if (action.payload) { //darknode set
        state.darkMode = true;
        state.theme = {
          ...themeConfig,
          palette: {
            ...themeConfig.palette,
            primary: state.theme.palette.primary,
            secondary: state.theme.palette.secondary,
            type: "dark"
          }
        };
      } else {
        state.darkMode = false;
        state.theme = {
          ...themeConfig,
          palette: {
            ...themeConfig.palette,
            primary: state.theme.palette.primary,
            secondary: state.theme.palette.secondary
          }
        };
      }

      state.value = action.payload;
    },
    swapThemeColors: (state, action) => {
      localStorage.setItem('fiscall-colors-swapped', action.payload);
      if (action.payload) { // colorsSwaped
        state.colorsSwaped = true;
        state.theme = {
            ...themeConfig,
            palette: {
              ...state.theme.palette,
              primary: secondaryColor,
              secondary: primaryColor
            }
          };
      } else {
        state.colorsSwaped = false;
        state.theme = {
          ...themeConfig,
          palette: {
            ...state.theme.palette,
            primary: primaryColor,
            secondary: secondaryColor
          }
        };
      }
    },
  },
});

export const { toggleThemeMode, swapThemeColors } = settings.actions;

export const isDarkMode = state => state.settings.darkMode;

export const isColorSwaped = state => state.settings.colorsSwaped;

export const getTheme = state => state.settings.theme;

export default settings.reducer;